// src/pages/NewOrder.jsx
import React from 'react';
import CreateOrderPage from '../components/orders/CreateOrderPage';
import Header from '../components/Header'; // Your existing Header
import Sidebar from '../components/Sidebar'; // Your existing Sidebar

const SampleOrder = () => {
  return (
   <div className="flex h-screen bg-gray-50">
  {/* Sidebar */}
  <Sidebar />

  {/* Main content */}
  <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
    <Header />

    <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">

          {/* Use the component for a REGULAR order */}
          <CreateOrderPage orderType="regular" />
          
          {/* Or uncomment this for a SAMPLE order */}
          {/* <CreateOrderPage orderType="sample" /> */}
        </div>
      </div>
    </div>
  );
};

export default SampleOrder;